export default __webpack_public_path__ + "static/media/wallet-connect-logo.1b9bf0ba.svg";